import React from 'react';
import './styles.scss';
export const CheckBox = (props) => {
  return (
    <li className="checkbox-container" key={`li-${props.id}`}>
      <label className="container">
        <div dangerouslySetInnerHTML={{ __html: props.value }} />
        <input
          type="checkbox"
          value={props.id}
          key={`check-${props.id}`}
          checked={props.isChecked}
          onChange={(e) => {
            props.handleCheckChildElement(e);
          }}
        />
        <span
          className={`${props.isError ? 'error-mark' : 'check-mark'} `}
        ></span>
      </label>
    </li>
  );
};

export default CheckBox;
